import type { Pead } from "epsm-api-types/models";
import type React from "react";
import { memo, useId } from "react";
import { getDayRange } from "../../../lib/helpers/getDayRange";
import { useInitChart } from "../../../lib/hooks/useInitChart/useInitChart";
import { usePrepareDataForChart } from "../../../lib/hooks/usePrepareDataForChart/usePrepareDataForCharts";
import type { ChartData, DriftType } from "../../../types";

type Props = {
	relativeToSpy: boolean;
	classNames?: string;
	pead: Pead | null;
	ticker: string;
	type: DriftType;
	priceLine: ChartData;
	currentPeadAccy: number | string;
	isMainChart?: boolean;
	stdDev?: boolean;
	style?: React.CSSProperties;
	onClick?: (data: any) => void;
};

export const DriftChart: React.FC<Props> = memo(
	({
		relativeToSpy,
		pead,
		classNames = "",
		ticker,
		isMainChart = false,
		stdDev = false,
		type,
		priceLine,
		currentPeadAccy,
		...otherProps
	}) => {
		const chartId = useId();

		const timeLine = getDayRange(pead);
		const lines = usePrepareDataForChart(
			relativeToSpy,
			pead,
			timeLine,
			priceLine,
			isMainChart,
			stdDev,
		);

		useInitChart(
			pead,
			chartId,
			lines,
			timeLine,
			currentPeadAccy,
			isMainChart,
			relativeToSpy,
			priceLine,
			stdDev,
		);

		return (
			<div
				id={`drift-chart-${chartId}`}
				data-testid="drift-chart"
				{...otherProps}
				className={`w-full w-min-[500px] relative ${classNames} border-2 border-gray`}
			>
				{!pead && (
					<p className="text-gold absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
						No data
					</p>
				)}
			</div>
		);
	},
);

DriftChart.displayName = "DriftChart";
